/*
 * Zentrale Registry für automatisch erkennbare Help Terms.
 *
 * Texte liegen in:
 *   src/i18n/de/help.json
 *   src/i18n/en/help.json
 *
 * Ausführliche Navigation läuft über helpTargets.js.
 */

export const helpTerms = {
  statisticsModel: { autoLink: false, tooltipKey: "help.terms.statisticsModel", terms: {de: [], en: []} },
  resultModel: { autoLink: false, tooltipKey: "help.terms.resultModel", terms: {de: [], en: []} },
  marketExpectation: { autoLink: false, tooltipKey: "help.terms.marketExpectation", terms: {de: [], en: []} },
  expectedStatistic: { autoLink: false, tooltipKey: "help.terms.expectedStatistic", terms: {de: [], en: []} },
  actualStatistic: { autoLink: false, tooltipKey: "help.terms.actualStatistic", terms: {de: [], en: []} },
  modelDifference: { autoLink: false, tooltipKey: "help.terms.modelDifference", terms: {de: [], en: []} },
  oneXTwo: { autoLink: false, tooltipKey: "help.terms.oneXTwo", terms: {de: [], en: []} },

  fairOdds: {
    target: "fairOdds",
    autoLink: true,
    tooltipKey: "help.terms.fairOdds",
    terms: {
      de: [
        "faire Quote",
        "faire Quoten",
        "fairen Quote",
        "fairen Quoten",
      ],
      en: [
        "Fair Odds",
        "fair odds",
        "Fair Price",
        "fair price",
      ],
    },
  },

  marketOdds: {
    target: "marketOddsAndValue",
    autoLink: true,
    tooltipKey: "help.terms.marketOdds",
    terms: {
      de: [
        "Marktquote",
        "Marktquoten",
      ],
      en: [
        "market odds",
        "market price",
      ],
    },
  },

  value: {
    target: "value",
    autoLink: true,
    tooltipKey: "help.terms.value",
    terms: {
      de: [
        "Value",
      ],
      en: [
        "Value",
        "value",
      ],
    },
  },

  valueBet: {
    target: "value",
    autoLink: true,
    tooltipKey: "help.terms.valueBet",
    terms: {
      de: [
        "Value Bet",
        "Value Bets",
      ],
      en: [
        "Value Bet",
        "Value Bets",
        "value bet",
        "value bets",
      ],
    },
  },

  fixture: {
    target: null,
    autoLink: true,
    tooltipKey: "help.terms.fixture",
    terms: {
      de: [
        "Fixture",
        "Fixtures",
      ],
      en: [
        "Fixture",
        "Fixtures",
        "fixture",
        "fixtures",
      ],
    },
  },

  teamSettings: {
    target: "teamSettings",
    autoLink: true,
    tooltipKey: "help.terms.teamSettings",
    terms: {
      de: [
        "Team Settings",
      ],
      en: [
        "Team Settings",
        "team settings",
      ],
    },
  },


  teamStrengths: {
    target: "teamStrengths",
    autoLink: true,
    tooltipKey: "help.terms.teamStrengths",
    terms: {
      de: [
        "Teamstärken",
        "Teamstärke",
        "Team Strengths",
        "Team Strength",
      ],
      en: [
        "Team Strengths",
        "Team Strength",
        "team strengths",
        "team strength",
      ],
    },
  },

  seasonParameters: {
    target: "seasonParameters",
    autoLink: true,
    tooltipKey: "help.terms.seasonParameters",
    terms: {
      de: [
        "Season Parameters",
        "Saisonparameter",
      ],
      en: [
        "Season Parameters",
        "Season Parameter",
        "season parameters",
        "season parameter",
      ],
    },
  },

  homeAdvantage: {
    target: "homeAdvantage",
    autoLink: true,
    tooltipKey: "help.terms.homeAdvantage",
    terms: {
      de: [
        "Heimvorteil",
        "Home Advantage",
        "Home-Advantage-Faktor",
      ],
      en: [
        "Home Advantage",
        "Home Advantage factor",
        "home advantage",
      ],
    },
  },

  expectedGoals: {
    target: "expectedGoals",
    autoLink: true,
    tooltipKey: "help.terms.expectedGoals",
    terms: {
      de: [
        "Expected Goals",
        "Torerwartungen",
        "Torerwartung",
      ],
      en: [
        "Expected Goals",
        "Goal Expectancy",
        "Goal Expectancies",
        "goal expectancy",
      ],
    },
  },

  shouldGoals: {
    target: "shouldGoals",
    autoLink: true,
    tooltipKey: "help.terms.shouldGoals",
    terms: {
      de: [
        "Should Goals",
      ],
      en: [
        "Should Goals",
      ],
    },
  },

  closedModel: {
    target: "closedModel",
    autoLink: true,
    tooltipKey: "help.terms.closedModel",
    terms: {
      de: [
        "geschlossenes System",
        "geschlossenen System",
        "geschlossenes Modell",
        "geschlossene Modell",
        "Closed System",
        "Closed Model",
      ],
      en: [
        "Closed System",
        "closed system",
        "Closed Model",
        "closed model",
      ],
    },
  },

  goalRatio: {
    target: "goalRatio",
    autoLink: true,
    tooltipKey: "help.terms.goalRatio",
    terms: {
      de: [
        "Torquotient",
        "Torverhältnis",
        "Goal Ratio",
      ],
      en: [
        "Goal Ratio",
        "goal ratio",
      ],
    },
  },

  goalLevel: {
    target: "goalLevel",
    autoLink: true,
    tooltipKey: "help.terms.goalLevel",
    terms: {
      de: [
        "Torniveau",
        "Goal Level",
      ],
      en: [
        "Goal Level",
        "goal level",
      ],
    },
  },

  goalAverage: {
    target: "goalAverage",
    autoLink: true,
    tooltipKey: "help.terms.goalAverage",
    terms: {
      de: [
        "Toreschnitt",
        "Goal Average",
      ],
      en: [
        "Goal Average",
        "goal average",
      ],
    },
  },

  statisticWeight: {
    target: "statisticWeight",
    autoLink: true,
    tooltipKey: "help.terms.statisticWeight",
    terms: {
      de: [
        "Statistikgewicht",
        "Statistic Weight",
        "Statistic Weights",
      ],
      en: [
        "Statistic Weight",
        "Statistic Weights",
        "statistic weight",
        "statistic weights",
      ],
    },
  },

  attackMoments: {
    target: "attackMoments",
    autoLink: true,
    tooltipKey: "help.terms.attackMoments",
    terms: {
      de: [
        "Attack Moments",
      ],
      en: [
        "Attack Moments",
        "attack moments",
      ],
    },
  },

  conversionRate: {
    target: "conversionRate",
    autoLink: true,
    tooltipKey: "help.terms.conversionRate",
    terms: {
      de: [
        "Conversion Rate",
        "Conversion",
      ],
      en: [
        "Conversion Rate",
        "Conversion",
        "conversion rate",
        "conversion",
      ],
    },
  },

  standardConversionRate: {
    target: "standardConversionRate",
    autoLink: true,
    tooltipKey: "help.terms.standardConversionRate",
    terms: {
      de: [
        "Standard Conversion Rate",
      ],
      en: [
        "Standard Conversion Rate",
        "standard conversion rate",
      ],
    },
  },


  compilation: {
    target: "compilation",
    autoLink: true,
    tooltipKey: "help.terms.compilation",
    terms: {
      de: [
        "Compile",
        "Compilation",
        "Kompilieren",
      ],
      en: [
        "Compile",
        "Compilation",
        "compile",
        "compilation",
      ],
    },
  },

  evaluation: {
    target: "evaluation",
    autoLink: true,
    tooltipKey: "help.terms.evaluation",
    terms: {
      de: [
        "Evaluate",
        "Evaluation",
        "Evaluieren",
        "Auswertung",
      ],
      en: [
        "Evaluate",
        "Evaluation",
        "evaluate",
        "evaluation",
      ],
    },
  },

  simulation: {
    target: "simulation",
    autoLink: true,
    tooltipKey: "help.terms.simulation",
    terms: {
      de: [
        "Simulation",
        "Simulieren",
      ],
      en: [
        "Simulation",
        "Simulate",
        "simulation",
        "simulate",
      ],
    },
  },

  goalExpectancy: {
    target: "goalExpectancy",
    autoLink: true,
    tooltipKey: "help.terms.goalExpectancy",
    terms: {
      de: [
        "Goal Expectancy",
        "Torerwartung",
        "Torerwartungen",
      ],
      en: [
        "Goal Expectancy",
        "Goal Expectancies",
        "goal expectancy",
        "goal expectancies",
      ],
    },
  },

  tableComparison: {
    target: "tableComparison",
    autoLink: true,
    tooltipKey: "help.terms.tableComparison",
    terms: {
      de: [
        "Table Comparison",
        "Tabellenvergleich",
      ],
      en: [
        "Table Comparison",
        "table comparison",
      ],
    },
  },

  drawFactor: {
    target: "drawFactor",
    autoLink: true,
    tooltipKey: "help.terms.drawFactor",
    terms: {
      de: [
        "Unentschieden-Faktor",
        "Remisfaktor",
        "Draw Factor",
        "Draw-Faktor",
      ],
      en: [
        "Draw Factor",
        "draw factor",
      ],
    },
  },

  averageExpectedProbability: {
    target: "averageExpectedProbability",
    autoLink: true,
    tooltipKey: "help.terms.averageExpectedProbability",
    terms: {
      de: [
        "Average Expected Probability",
      ],
      en: [
        "Average Expected Probability",
        "average expected probability",
      ],
    },
  },

  averageOccurredProbability: {
    target: "averageOccurredProbability",
    autoLink: true,
    tooltipKey: "help.terms.averageOccurredProbability",
    terms: {
      de: [
        "Average Occurred Probability",
      ],
      en: [
        "Average Occurred Probability",
        "average occurred probability",
      ],
    },
  },

  averageExpectedGoalDeviation: {
    target: "averageExpectedGoalDeviation",
    autoLink: true,
    tooltipKey: "help.terms.averageExpectedGoalDeviation",
    terms: {
      de: [
        "Average Goal Deviation Expected",
        "Average Expected Goal Deviation",
      ],
      en: [
        "Average Goal Deviation Expected",
        "Average Expected Goal Deviation",
        "average expected goal deviation",
      ],
    },
  },

  averageOccurredGoalDeviation: {
    target: "averageOccurredGoalDeviation",
    autoLink: true,
    tooltipKey: "help.terms.averageOccurredGoalDeviation",
    terms: {
      de: [
        "Average Goal Deviation Occurred",
        "Average Occurred Goal Deviation",
      ],
      en: [
        "Average Goal Deviation Occurred",
        "Average Occurred Goal Deviation",
        "average occurred goal deviation",
      ],
    },
  },

  reciprocal: {
    target: null,
    autoLink: true,
    tooltipKey: "help.terms.reciprocal",
    terms: {
      de: [
        "Kehrwert",
      ],
      en: [
        "reciprocal",
      ],
    },
  },

  expectedTable: {
    target: "expectedTable",
    autoLink: true,
    tooltipKey: "help.terms.expectedTable",
    terms: {
      de: [
        "Expected Table",
      ],
      en: [
        "Expected Table",
      ],
    },
  },

  shouldTable: {
    target: "shouldTable",
    autoLink: true,
    tooltipKey: "help.terms.shouldTable",
    terms: {
      de: [
        "Should Table",
      ],
      en: [
        "Should Table",
      ],
    },
  },

  matchStatistics: {
    target: null,
    autoLink: true,
    tooltipKey: "help.terms.matchStatistics",
    terms: {
      de: [
        "Match Statistics",
      ],
      en: [
        "Match Statistics",
      ],
    },
  },

  actualTable: {
    target: "actualTable",
    autoLink: true,
    tooltipKey: "help.terms.actualTable",
    terms: {
      de: [
        "Actual",
        "Actual Table",
      ],
      en: [
        "Actual",
        "Actual Table",
      ],
    },
  },

  tableStats: {
    target: "tableStats",
    autoLink: true,
    tooltipKey: "help.terms.tableStats",
    terms: {
      de: [
        "Table Stats",
      ],
      en: [
        "Table Stats",
      ],
    },
  },
};

export function getHelpTerms(language = "de") {
  const normalizedLanguage =
    language === "de" ? "de" : "en";

  return Object.entries(helpTerms)
    .filter(([, config]) => config.autoLink !== false)
    .flatMap(([key, config]) =>
      (config.terms?.[normalizedLanguage] || []).map((term) => ({
        key,
        term,
        target: config.target || null,
        tooltipKey: config.tooltipKey,
      }))
    )
    .sort((a, b) => b.term.length - a.term.length);
}

export function getHelpTerm(key) {
  return helpTerms[key] || null;
}
